module.exports = __webpack_public_path__ + "static/img/incheon-ag-tech.a0654dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/incheon-ag-tech.jpg
// module id = xbd1
// module chunks = 0